import { Fragment } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useLanguage } from "../context/LanguageContext";
import ManualLink from "./ManualLink";

// `manual` = { settlementType, section }: see ManualLink.
export default function SetupPageHeader({ title, description, sx, manual = null }) {
  const { translateText } = useLanguage();

  return (
    <Stack spacing={1} sx={sx}>
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", columnGap: 1.5, rowGap: 0.5 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.01em",
            color: "text.primary",
          }}
        >
          {translateText(title)}
        </Typography>
        {manual ? <ManualLink settlementType={manual.settlementType} section={manual.section} /> : null}
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          maxWidth: "100%",
          lineHeight: 1.6,
        }}
      >
        {(Array.isArray(description) ? description : [description]).map((line, index) => (
          <Fragment key={index}>
            {index > 0 && <br />}
            {translateText(line)}
          </Fragment>
        ))}
      </Typography>
      <Box
        sx={{
          width: 88,
          height: 3,
          borderRadius: 999,
          backgroundColor: "primary.main",
        }}
      />
    </Stack>
  );
}
